// Definition of the colors used in the design system (KEY = color primitive, VALUE = color token)
export enum DSChartColors {
  GREEN = 'green',
  GREEN_SUBDUED = 'green-subdued',
  GREEN_SUBDUED_HOVER = 'green-subdued-hover',
  GREEN_ACTIVE = 'green-active',
  GREEN_HOVER = 'green-hover',
  YELLOW = 'yellow',
  YELLOW_SUBDUED = 'yellow-subdued',
  YELLOW_SUBDUED_HOVER = 'yellow-subdued-hover',
  YELLOW_ACTIVE = 'yellow-active',
  YELLOW_HOVER = 'yellow-hover',
  ORANGE = 'orange',
  PURPLE = 'purple',
  PURPLE_SUBDUED = 'purple-subdued',
  PURPLE_SUBDUED_HOVER = 'purple-subdued-hover',
  PURPLE_ACTIVE = 'purple-active',
  PURPLE_HOVER = 'purple-hover',
  PINK = 'pink',
  BLUE = 'blue',
  LIGHTBLUE = 'lightblue',
  GREY = 'grey',
  GREY_SUBDUED = 'grey-subdued',
  GREY_SUBDUED_HOVER = 'grey-subdued-hover',
  GREY_ACTIVE = 'grey-active',
  GREY_HOVER = 'grey-hover',
  DARK = 'dark',
  TRANSPARENT = 'transparent'
}

export enum DSFunctionalColors {
  POSITIVE = 'positive',
  NEGATIVE = 'negative',
  WARNING = 'warning'
}
